// Shared between the settlements tab and the ledger-journals settings
// section (pr5-contract.md §1/§3). More kinds may be added on the backend
// later — an unrecognised one must still render, showing its raw code
// rather than a translated-but-wrong label.
export const LEDGER_KIND_LABEL_KEYS: Record<string, string> = {
  sale: "ledger_kind_sale",
  sale_return: "ledger_kind_sale_return",
  purchase: "ledger_kind_purchase",
  purchase_return: "ledger_kind_purchase_return",
};

export function ledgerKindLabel(
  t: (key: string, options?: any) => string,
  kind: string
): string {
  const i18nKey = LEDGER_KIND_LABEL_KEYS[kind];
  return i18nKey ? t(i18nKey) : kind;
}
